module.exports = __webpack_public_path__ + "img/NSF_Logo_flat.5c33e5e7.png";